import React from 'react';
import { StepProps } from '../MultiStepModal';
import { FormField, TextInput } from '../../ui';

export default function ClientContactStep({ data, onDataChange }: StepProps) {
  const setField = (field: string, value: any) => onDataChange({ [field]: value });
  const billingSameAsPrimary = data.billingSameAsPrimary !== false;

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">How do we reach them?</h3>
        <p className="step-form-subtitle">
          Phone is required so engineers can confirm visits; email is used for quotes, invoices
          and portal access.
        </p>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Primary contact</h4>
        <div className="ui-wizard-grid">
          <FormField label="Phone number" required htmlFor="customerPhone">
            <TextInput
              id="customerPhone"
              type="tel"
              placeholder="+44 20 7123 4567"
              value={data.customerPhone || ''}
              onChange={(e) => setField('customerPhone', e.target.value)}
            />
          </FormField>
          <FormField label="Email" htmlFor="customerEmail" help="Optional, but required to invite them to the client portal">
            <TextInput
              id="customerEmail"
              type="email"
              placeholder="john@example.com"
              value={data.customerEmail || ''}
              onChange={(e) => setField('customerEmail', e.target.value)}
            />
          </FormField>
        </div>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Billing</h4>
        <label className="ui-wizard-checkbox">
          <input
            type="checkbox"
            checked={billingSameAsPrimary}
            onChange={(e) => setField('billingSameAsPrimary', e.target.checked)}
          />
          <span>Send invoices to the primary email</span>
        </label>
        {!billingSameAsPrimary && (
          <div className="ui-wizard-grid">
            <FormField label="Billing email" htmlFor="billingEmail" className="ui-wizard-grid-col-span">
              <TextInput
                id="billingEmail"
                type="email"
                placeholder="accounts@example.com"
                value={data.billingEmail || ''}
                onChange={(e) => setField('billingEmail', e.target.value)}
              />
            </FormField>
          </div>
        )}
      </div>
    </div>
  );
}
